import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Needed for Touch functionality of Material Components
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ApiService } from './services/base/api.service';
import { SnackbarService } from './services/base/snackbar.service';
import { AddAcceptInterceptor } from './interceptors/add-accept.interceptor';
import { ApiEndpointsService } from './services/base/api-endpoints.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatetimeAdapter } from '@ng-matero/extensions/core';
import { MomentDatetimeAdapter } from '@ng-matero/extensions-moment-adapter';
import { LightboxModule } from 'ng-gallery/lightbox';
import { WebformService } from './services/reports/webform.service';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import { FiltersService } from './services/base/filters.service';
import { FuryAlertBoxModule } from '../@fury/shared/alert-box/alert-box.module';
import { PublicNotificationsService } from './services/configuration/public-notifications.service';
import { LayoutService } from './layout/layout.service';
import { AuthenticationService } from './services/base/authentication.service';
import { LocalStorageService } from './services/base/local-storage.service';
import { MaterialModule } from '../@fury/shared/material-components.module';
import { LoadingOverlayModule } from '../@fury/shared/loading-overlay/loading-overlay.module';
import { FurySharedModule } from '../@fury/fury-shared.module';
import { ScrollSpyModule } from '../@fury/shared/scroll-spy/scroll-spy.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgxLoadingControlModule } from '@runette/ngx-leaflet-loading';
import { PdokService } from './services/external/pdok.service';
import { LeafletMapService } from './services/base/leaflet-map.service';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { ControlComponent } from './pages/control/control.component';
import { NormalFormComponent } from './pages/normal-form/normal-form.component';
import { ReceivedComponent } from './pages/received/received.component';
import { PublicNotificationsComponent } from './pages/public-notifications/public-notifications.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    // Angular Core Module // Don't remove!
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,

    // Fury Core Modules
    AppRoutingModule,

    // Layout Module (Sidenav, Toolbar, Quickpanel, Content)
    LayoutModule,

    LightboxModule.withConfig({
      panelClass: 'fullscreen'
    }),

    FuryAlertBoxModule,

    MaterialModule,
    LoadingOverlayModule,
    FurySharedModule,
    ScrollSpyModule,
    LeafletModule,
    NgxLoadingControlModule,
    MaterialFileInputModule,

    NgxMaskModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    ControlComponent,
    NormalFormComponent,
    ReceivedComponent,
    PublicNotificationsComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: DatetimeAdapter,
      useClass: MomentDatetimeAdapter,
    },
    {provide: MAT_DATE_LOCALE, useValue: 'nl-NL'},
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'DD-MM-YY'
        },
        display: {
          dateInput: 'DD-MM-YY',
          monthLabel: 'MMMM',
          monthYearLabel: 'MMMM YYYY',
          dateA11yLabel: 'MMMM',
          monthYearA11yLabel: 'YYYY'
        }
      }
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      }
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill'
      } as MatFormFieldDefaultOptions
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom'
      } as MatSnackBarConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddAcceptInterceptor,
      multi: true
    },
    ApiEndpointsService,
    ApiService,
    AuthenticationService,
    LocalStorageService,

    PdokService,
    LeafletMapService,


    LayoutService,
    SnackbarService,
    WebformService,
    FiltersService,
    PublicNotificationsService,
  ]
})
export class AppModule {
}
